/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum MarkupStateFilter {
  MarkedUp = "MarkedUp",
  MarkedDown = "MarkedDown",
  HasFixedMarkup = "HasFixedMarkup",
}

export function instanceOfMarkupStateFilter(value: any): boolean {
  for (const key in MarkupStateFilter) {
    if (Object.prototype.hasOwnProperty.call(MarkupStateFilter, key)) {
      if (MarkupStateFilter[key as keyof typeof MarkupStateFilter] === value) {
        return true;
      }
    }
  }
  return false;
}

export function MarkupStateFilterFromJSON(json: any): MarkupStateFilter {
  return MarkupStateFilterFromJSONTyped(json, false);
}

export function MarkupStateFilterFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MarkupStateFilter {
  return json as MarkupStateFilter;
}

export function MarkupStateFilterToJSON(value?: MarkupStateFilter | null): any {
  return value as any;
}

export function MarkupStateFilterToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): MarkupStateFilter {
  return value as MarkupStateFilter;
}
